import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { bg_button } from "constant/css";
import { useMerchant } from "context/merchantContext";

const { Option } = Select;

const ENVIRONMENTS = {
  test: "https://apitest.esukh.mn",
  prod: "https://api.esukh.mn",
};
const ENVIRONMENTS_XPAY = {
  test: "https://apispay.esukh.mn",
  prod: "https://apispay.esukh.mn",
};

const billingEndpoints = {
  title: "Хэрэглэгчдийн төлбөрийн мэдээллийг авах, баталгаажуулах, төлөх API",
  docUrl:
    "https://storage.googleapis.com/smartbilling_hubilai/documents/%D0%A1%D0%BC%D0%B0%D1%80%D1%82%D0%B1%D0%B8%D0%BB%D0%BB%D0%B8%D0%BD%D0%B3_doc_V2.postman_collection.json",
  envUrl:
    "https://storage.googleapis.com/smartbilling_hubilai/documents/esukh_v2_test.postman_environment.json",
  baseUrl: ENVIRONMENTS,
  endPoints: [
    {
      title: "Login",
      method: "POST",
      path: "/api/v1/billing/partner/login",
      desc: "Нэвтрэх нэр, нууц үг ашиглан токэн авна.",
      body: `{
  "username": "MERCHANT_1",
  "password": "MERCHANT_SECRET"
}`,
    },
    {
      title: "Refresh Token",
      method: "POST",
      path: "/api/v1/billing/partner/refresh_token",
      desc: "refresh_token ашиглан дахин богино токэн авна.",
      body: `{
  "refresh_token": "eyJhbGciOiJIUzI1NiIs..."
}`,
    },
    {
      title: "User OTP",
      method: "POST",
      path: "/api/v1/billing/user/otp",
      desc: "Утасны дугаараар OTP илгээх.",
      body: `{
  "phone": "86963023"
}`,
    },
    {
      title: "Check OTP & get TOKEN",
      method: "POST",
      path: "/api/v1/billing/user/otp/check",
      desc: "OTP код шалгаж токэн авна.",
      body: `{
  "phone": "86963023",
  "code": 8383
}`,
    },
    {
      title: "Get user bills",
      method: "POST",
      path: "/api/v1/billing/user/bills",
      desc: "user_token ашиглан хэрэглэгчийн бүх билл лавлах.",
      body: `{
  "user_token": "{{user_token}}"
}`,
    },
    {
      title: "Get user bills count by property",
      method: "POST",
      path: "/api/v1/billing/user/bills/count",
      desc: "ҮХХ дээрх идэвхтэй билл тоо авах.",
      body: `{
  "user_token": "{{user_token}}",
  "properties": [1897]
}`,
    },
    {
      title: "Get user bill by property",
      method: "POST",
      path: "/api/v1/billing/user/bills/byProperty/:propertyId",
      desc: "Нэг ҮХХ дээрх билл авах.",
      body: `{
  "user_token": "{{user_token}}"
}`,
    },
    {
      title: "Bill set paid",
      method: "POST",
      path: "/api/v1/billing/user/bills/paid",
      desc: "Билл төлөлт бүртгэх.",
      body: `{
  "refId": 123,
  "paymentInvoices": [
    {
      "invoiceId": 4000895,
      "amount": 100
    }
  ],
  "user_token": "{{user_token}}"
}`,
    },
    {
      title: "Get VAT",
      method: "POST",
      path: "/api/v1/billing/user/bills/:id/vat",
      desc: "Төлсөн билл-ийн НӨАТ авах.",
      body: `{
  "user_token": "{{user_token}}"
}`,
    },
  ],
};

const xPayEndpoints = {
  title: "Хялбараар төлбөр хүлээн авах API",
  docUrl:
    "https://storage.googleapis.com/smartbilling_hubilai/documents/API%20Documentation%20USERS.postman_collection.json",
  baseUrl: ENVIRONMENTS_XPAY,
  endPoints: [
    {
      title: "Login",
      method: "POST",
      path: "/api/v1/merchant/auth",
      desc: "Нэвтрэх нэр, нууц үг ашиглан токэн авна.",
      body: `{
            "username": "MERCHANT_1",
            "password": "MERCHANT_PASS"
          }`,
    },
    {
      title: "Create Invoice",
      method: "POST",
      path: "/api/v1/invoice",
      desc: "Нэхэмжлэл үүсгэх",
      body: `{
    "amount":{{amount}},
    "phone":"{{user_phone}}",
    "description":"{{description}}",
    "returnUrl":"{{redirect_url}}",
    "successCallback":{{success_callback}},
    "invoiceItems":[
           {
                "amount":{{amount}},
                "accountNumber":{{bank_account_number}},
                "bankCode":{{bank_code}},
                "description":{{description}},
                "productTypeId":6,
                "successCallback":{{success_callback}},
                "vatInfo":{
                    "merchantRegister":{{merchant_register}},
                    "type":"B2C" | "B2B",
                    "companyRegister":{{merchant_register}}
                }
  }]`,
    },
    {
      title: "Check Invoice by secureId",
      method: "POST",
      path: "/api/v1/invoice/bySecureId/:id/check",
      desc: "SecureId ашиглан нэхэмжлэлийн төлөв шалгах.",
      body: `{
            "username": "MERCHANT_1",
            "password": "MERCHANT_PASS"
          }`,
    },
  ],
};
const BillingDoc = () => {
  const [data, setData] = useState(null);
  const { permissions } = useMerchant();
  const xpayUser = permissions?.find((e) => e === 2) || false;
  const [activeUrl, setActiveUrl] = useState("prod");
  useEffect(() => {
    if (xpayUser) setData(xPayEndpoints);
    else setData(billingEndpoints);
  }, [xpayUser]);
  const downloadPostmanDoc = (e) => {
    const docUrl = e;
    window.open(docUrl, "_blank");

    // const link = document.createElement("a");
    // link.href = docUrl;
    // link.download = "smartbilling.postman_collection.json";
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };
  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <div
        className={`${bg_button} p-6 rounded-2xl mb-8 shadow-sm border border-green-200`}
      >
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-100">
              Смартбиллинг API гарын авлага
            </h1>
            <p className="text-gray-200 mt-1 text-sm">
              {data?.title || "API гарын авлага ачааллаж байна..."}
            </p>
          </div>

          <div className="flex items-center gap-4 flex-col">
            <Select
              value={activeUrl}
              className="w-52"
              size="small"
              onChange={(e) => setActiveUrl(e)}
              options={Object.entries(ENVIRONMENTS).map(([key, value]) => ({
                label: key === "test" ? "🧪 Туршилт" : "🚀 Бодит орчин",
                value: key,
              }))}
            />
            <div
              onClick={() => downloadPostmanDoc(data?.docUrl)}
              className="inline-flex items-center gap-2 cursor-pointer bg-[#FF6C37] hover:bg-[#e75b2b] text-white font-semibold text-sm px-4 py-2 rounded-md shadow transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l-4-4m4 4l4-4"
                />
              </svg>
              Postman endpoints
            </div>
            <div
              onClick={() => downloadPostmanDoc(data?.envUrl)}
              className="inline-flex items-center gap-2 cursor-pointer bg-[#FF6C37] hover:bg-[#e75b2b] text-white font-semibold text-sm px-4 py-2 rounded-md shadow transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l-4-4m4 4l4-4"
                />
              </svg>
              Postman environment
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {data?.endPoints.map((ep, idx) => (
          <div
            key={idx}
            className="bg-white border border-gray-100 rounded-xl shadow-md p-5"
          >
            <div className="flex justify-between items-center mb-2">
              <div>
                <span className="text-sm font-medium text-yellow-600 mr-2">
                  {ep.method}
                </span>
                <span className="font-semibold text-gray-800">{ep.title}</span>
              </div>
              <span className="text-xs text-[#66baa8] font-mono break-all">
                {data?.baseUrl[activeUrl] + ep.path}
              </span>
            </div>
            <p className="text-sm text-gray-600">{ep.desc}</p>

            <div className="mt-3">
              <label className="text-xs font-semibold text-gray-500 mb-1 block">
                JSON Body:
              </label>
              <pre className="bg-gray-50 text-sm text-gray-800 p-3 rounded border border-gray-200 overflow-auto whitespace-pre-wrap">
                {ep.body}
              </pre>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BillingDoc;
